import { myAxios } from "./axios"

export function getCars(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/cars", config)
}

export function getCar(id) {
    return myAxios.get("/cars/" + id)
}

export function addCar(data) {
    return myAxios.post("/cars/create", data)
}

export function editCar(id, data) {
    return myAxios.put("/cars/" + id + "/update", data)
}

export function deleteCar(id) {
    return myAxios.delete("/cars/" + id + "/delete")
}

export function getCarRenters(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})
        },
    }
    return myAxios.get(`/cars/${data.carId}/renters`, config)
}
